import { DocumentCheckOutlineIcon } from '@applyboard/ui-icons';
import { Flex, Text, Timeline, Tag } from '@applyboard/crystal-ui';
import { useAppProcessing } from '../../context';

import { Card } from './Card';

export function ApplicationTimeline() {
  const {
    application: { applicationHistory },
  } = useAppProcessing();

  if (applicationHistory.length === 0) return null;

  return (
    <Card id="applicationTimeline" icon={DocumentCheckOutlineIcon} title="Application Timeline" hideChevron>
      <Flex justify="start" direction="column">
        <Timeline aria-label="Application Timeline" columnGap={4} orientation="vertical">
          {applicationHistory.map((item) => (
            <Timeline.Item key={item.updatedAt}>
              <Timeline.Item.Dot icon="check" variant="fill" align="start" intent="positive" />
              <Tag intent={item.intent} icon="fill">
                {item.label}
              </Tag>
              <Flex gap={2}>
                <Text contrast="low" variant="bodyS" as="span">
                  {new Date(item.updatedAt).toLocaleDateString(undefined, {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                  })}
                </Text>
              </Flex>
            </Timeline.Item>
          ))}
        </Timeline>
      </Flex>
    </Card>
  );
}
